import { Link, useParams } from 'react-router-dom'
import './EquipmentItem.css'

function EquipmentItemPage({ t }) {
  const { slug } = useParams()
  const { items, backLabel, notFound } = t.equipment
  const item = items.find((entry) => entry.slug === slug)

  if (!item) {
    return (
      <section className="section equipment-item-page">
        <div className="section-header">
          <h2>{notFound}</h2>
        </div>
        <Link className="equipment-back" to="/equipment">
          {backLabel}
        </Link>
      </section>
    )
  }

  const initials = item.name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('')

  return (
    <div className="page">
    <section className="section equipment-item-page">
      <Link className="equipment-back" to="/equipment">
        {backLabel}
      </Link>
      <div className="equipment-item-card">
        <div className="equipment-item-media" aria-hidden="true">
          <span>{initials}</span>
        </div>
        <div className="equipment-item-detail">
          <div>
            <h2>{item.name}</h2>
            <div className="equipment-item-meta">
              <span className="equipment-price">{item.price}</span>
            </div>
          </div>
          <div>
            <p className="equipment-item-label">Description</p>
            <p className="equipment-item-description">{item.description}</p>
          </div>
          <div className="equipment-item-actions">
            <Link className="equipment-item-btn equipment-item-btn-primary" to="/contact">
              Contact Sales
            </Link>
            <a className="equipment-item-btn equipment-item-btn-secondary" href="#specs">
              View Specs
            </a>
          </div>
          {item.images && item.images.length ? (
            <div className="equipment-item-gallery">
              {item.images.slice(0, 5).map((image, index) => (
                <div className="equipment-item-thumb" key={`${item.slug}-image-${index}`}>
                  <img src={image} alt={`${item.name} ${index + 1}`} />
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
    </div>
  )
}

export default EquipmentItemPage
